import { Tag } from "antd";
import { WithTranslation, withTranslation } from "react-i18next";
import { CollectionFolderTag } from "./interfaces";

interface FileTagProps extends WithTranslation {
  label: CollectionFolderTag;
}

export const FileTag = withTranslation()(({ t, label }: FileTagProps) => {
  const tagMap: { [key in CollectionFolderTag]?: string } = {
    DELETED: "MARKED AS DELETED",
    RWM: "WATERMARK REQ.",
    UPLOADED: "UPLOADED",
    "PRINT JOB": "PRINT JOB",
  };
  return <Tag color="magenta">{t(tagMap[label])}</Tag>;
});
